const COLLES_WITHOUT_STRIPE_REQUIREMENT = new Set(['andorra', 'emboirats']);

export const canShareExternalForm = (colla, stripeFormsEnabled) =>
    stripeFormsEnabled || COLLES_WITHOUT_STRIPE_REQUIREMENT.has(String(colla || '').toLowerCase());
